module.exports = __webpack_public_path__ + "img/groupmobile.b5245c99.png";